import { Box, CircularProgress } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import * as React from "react";

import { useTableStyles } from "../../styles/tableStyles";

interface RemittanceRunnerRemittanceIsLoadingProps {
  className?: string;
  style?: React.CSSProperties;
  isTableFormat?: boolean;
  numberOfColumns?: number;
}

const RemittanceRunnerRemittanceIsLoading: React.FC<RemittanceRunnerRemittanceIsLoadingProps> = props => {
  const { className, style, isTableFormat, numberOfColumns } = props;

  const tblClasses = useTableStyles(props);
  return (
    <>
      <div className={className || tblClasses.responsiveTable} style={style}>
        {isTableFormat ? (
          <Table>
            <TableBody className={tblClasses.tblBody}>
              <TableRow>
                <TableCell colSpan={numberOfColumns}>
                  <Box className={tblClasses.boxStyles}>
                    <CircularProgress />
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : (
          <Box
            className={`${tblClasses.boxStyles} ${tblClasses.boxStylesForNonTableFormat}`}
          >
            <CircularProgress />
          </Box>
        )}
      </div>
    </>
  );
};

export default RemittanceRunnerRemittanceIsLoading;
